<template>
  <div>
    <v-container fluid class="admin-page pb-0">
      <v-row>
        <v-col cols="2">
          <v-btn
            class="text--futura text-capitalize"
            outlined
            @click="goBack"
          >
            Back to Affiliates
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <AffiliateForm
      :affiliate="affiliate"
      :formType="formType"
      :buttonLoading="buttonLoading"
      @saveAffiliate="updateAffiliate"
    />
  </div>
</template>

<script>
import server from "../api";
import AffiliateForm from "@/components/AffiliateForm.vue";

export default {
  name: "EditAffiliate",
  components: {
    AffiliateForm,
  },
  data() {
    return {
      formType: {
        text: "Edit",
        value: "edit",
      },
      buttonLoading: false,
    };
  },
  computed: {
    affiliate() {
      return this.$store.state.affiliate;
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Affiliate" });
    },
    updateAffiliate() {
      this.buttonLoading = true;
      server
        .put(
          `/affiliates/${this.affiliate.id}`,
          {
            full_name: this.affiliate.fullName,
            contact_number: this.affiliate.contactNumber,
          },
          {
            headers: {
              token: localStorage.token,
            },
          }
        )
        .then((result) => {
          this.buttonLoading = false;
          const affiliate = result.data.Affiliate || result.data.data || this.affiliate;
          this.$store.commit(
            "SET_SUCCESS",
            `Success update affiliate ${affiliate.fullName || affiliate.full_name}`
          );
          this.$router.push({ name: "Affiliate" });
        })
        .catch((err) => {
          this.buttonLoading = false;
          const errorMessage =
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            (Array.isArray(err.response.data.errors)
              ? err.response.data.errors[0].message
              : err.response.data.errors.message);

          this.$store.commit(
            "SET_ERROR",
            errorMessage || "Failed to update affiliate"
          );
        });
    },
  },
  created() {
    this.$store.dispatch("getAffiliateById", { id: this.$route.params.id });
  },
};
</script>

<style></style>
